/**
 * Anciennes adresses du stock et des achats (`/stock?onglet=…`,
 * `/fournisseurs?tab=…`), encore portées par des avis, des e-mails et des
 * signets : elles mènent à la liste du Matériel qui porte désormais leur
 * contenu, sans laisser d'entrée dans l'historique.
 */
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCan } from '../../core/auth.js';
import { legacyStockPath, legacySuppliersPath } from '../../app/materiel-sections.js';

export function LegacyStockRedirect(): ReactNode {
  const location = useLocation();
  return <Navigate to={legacyStockPath(location.search)} replace state={location.state} />;
}

export function LegacySuppliersRedirect(): ReactNode {
  const location = useLocation();
  const can = useCan();
  return <Navigate to={legacySuppliersPath(location.search, can)} replace state={location.state} />;
}
